
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/3cat/colleccions",
      function () {
        return require("private-next-pages/3cat/colleccions/index.js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/3cat/colleccions"])
      });
    }
  